import React, { useMemo, useState } from 'react';

export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100, 1000, 5000];

export function usePagination(items) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE_OPTIONS[0]);

  const totalItems = Array.isArray(items) ? items.length : 0;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  // Clamp instead of resetting so shrinking filters keep the user close to
  // where they were instead of snapping back to page 1.
  const currentPage = Math.min(page, totalPages);

  const pagedItems = useMemo(
    () => (Array.isArray(items) ? items.slice((currentPage - 1) * pageSize, currentPage * pageSize) : []),
    [items, currentPage, pageSize]
  );

  return {
    pagedItems,
    page: currentPage,
    pageSize,
    totalItems,
    totalPages,
    onPageChange: (nextPage) => setPage(Math.max(1, Math.min(Number(nextPage) || 1, totalPages))),
    onPageSizeChange: (nextSize) => {
      setPageSize(Number(nextSize) || PAGE_SIZE_OPTIONS[0]);
      setPage(1);
    },
  };
}

export default function TablePagination({ page, pageSize, totalItems, totalPages, onPageChange, onPageSizeChange }) {
  if (totalItems <= 0) {
    return null;
  }

  const start = (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalItems);

  return (
    <div className="profile-pagination-row">
      <select
        className="profile-per-page"
        value={pageSize}
        onChange={(event) => onPageSizeChange(Number(event.target.value))}
        aria-label="Rows per page"
      >
        {PAGE_SIZE_OPTIONS.map((size) => (
          <option key={size} value={size}>{size} / page</option>
        ))}
      </select>
      <button type="button" className="profile-page-btn" onClick={() => onPageChange(1)} disabled={page <= 1}>
        First
      </button>
      <button type="button" className="profile-page-btn" onClick={() => onPageChange(page - 1)} disabled={page <= 1}>
        Previous
      </button>
      <span className="table-pagination-info">
        Page {page} of {totalPages} ({start}-{end} of {totalItems})
      </span>
      <button type="button" className="profile-page-btn" onClick={() => onPageChange(page + 1)} disabled={page >= totalPages}>
        Next
      </button>
      <button type="button" className="profile-page-btn" onClick={() => onPageChange(totalPages)} disabled={page >= totalPages}>
        Last
      </button>
    </div>
  );
}
